/**
 * KAFFEESACK - Add-to-Cart Premium Feedback
 * =============================================
 * Version 5.0 - Fly-to-Cart + Sound + Haptic
 *
 * ANSATZ: Das Theme handled bereits die AJAX-Cart-Addition.
 * Dieses Script ERGAENZT das um ein Premium-Erlebnis:
 * 1. Fly-to-Cart: Produktbild fliegt zum Warenkorb-Icon
 * 2. Button-Pulse mit gruener Erfolgs-Animation
 * 3. Cart-Icon Bounce wenn das Bild "ankommt"
 * 4. Sound-Effekt (Web Audio, kein externer File)
 * 5. Haptisches Feedback (Vibration auf Android)
 * 6. Mobile: Elegante Bestaetigungs-Bar am unteren Rand
 * 7. Desktop: Cart-Drawer oeffnet sich automatisch
 *
 * INSTALLATION:
 * 1. Diese Datei unter Assets hochladen
 * 2. In layout/theme.liquid VOR </body>:
 *    {{ 'kaffeesack-atc-feedback.css' | asset_url | stylesheet_tag }}
 *    {{ 'kaffeesack-atc-feedback.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  var CONFIG = {
    buttonSuccessDuration: 2200,
    flyDuration: 650,
    drawerOpenDelay: 900,
    confirmBarDuration: 4000,
    cartDrawerOpenClass: 'cart--is-visible'
  };

  var CHECKMARK_SVG =
    '<svg class="ks-atc-check" viewBox="0 0 24 24" width="20" height="20">' +
    '<path d="M7 12.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" class="ks-atc-check__path"/>' +
    '</svg>';

  // ============================================================
  // SOUND (Web Audio API — erzeugt einen kurzen Premium-"Ding")
  // ============================================================
  var audioCtx = null;

  function playSuccessSound() {
    try {
      if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }
      var now = audioCtx.currentTime;

      // Zwei Toene ueberlagert fuer einen warmen, vollen Klang
      // Ton 1: E6 (1318 Hz) — Grundton
      var osc1 = audioCtx.createOscillator();
      var gain1 = audioCtx.createGain();
      osc1.type = 'sine';
      osc1.frequency.setValueAtTime(1318, now);
      osc1.frequency.exponentialRampToValueAtTime(1397, now + 0.06);
      gain1.gain.setValueAtTime(0, now);
      gain1.gain.linearRampToValueAtTime(0.1, now + 0.008);
      gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.35);
      osc1.connect(gain1);
      gain1.connect(audioCtx.destination);
      osc1.start(now);
      osc1.stop(now + 0.4);

      // Ton 2: G#6 (1661 Hz) — Oberton, leicht versetzt
      var osc2 = audioCtx.createOscillator();
      var gain2 = audioCtx.createGain();
      osc2.type = 'sine';
      osc2.frequency.setValueAtTime(1661, now + 0.05);
      gain2.gain.setValueAtTime(0, now + 0.05);
      gain2.gain.linearRampToValueAtTime(0.06, now + 0.058);
      gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
      osc2.connect(gain2);
      gain2.connect(audioCtx.destination);
      osc2.start(now + 0.05);
      osc2.stop(now + 0.35);
    } catch (e) { /* Web Audio nicht verfuegbar */ }
  }

  // ============================================================
  // HAPTIC FEEDBACK (Android)
  // ============================================================
  function hapticFeedback() {
    if (navigator.vibrate) {
      navigator.vibrate([12, 25, 12]);
    }
  }

  // ============================================================
  // FLY-TO-CART ANIMATION
  // Klont das Produktbild und laesst es zum Warenkorb-Icon fliegen
  // ============================================================
  function flyToCart() {
    // Produktbild finden (Kaffeesack: Flickity-Slider mit product-single__media)
    var productImg =
      document.querySelector('.product-gallery img') ||
      document.querySelector('.product-single__media img') ||
      document.querySelector('.flickity-cell.is-selected img') ||
      document.querySelector('.product__media img, .product__image img, .product-image img') ||
      document.querySelector('.product img[src*="cdn.shopify"]');

    // Warenkorb-Icon finden (Kaffeesack: a.cartToggle)
    var cartIcon =
      document.querySelector('a.cartToggle') ||
      document.querySelector('.header__cart') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[data-cart-count]');

    if (!productImg || !cartIcon) return;

    var imgRect = productImg.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();

    // Fliegendes Element erstellen
    var flyer = document.createElement('div');
    flyer.className = 'ks-fly-item';
    flyer.style.cssText =
      'position:fixed;z-index:100000;pointer-events:none;' +
      'width:' + Math.min(imgRect.width, 120) + 'px;' +
      'height:' + Math.min(imgRect.height, 120) + 'px;' +
      'left:' + (imgRect.left + imgRect.width / 2 - Math.min(imgRect.width, 120) / 2) + 'px;' +
      'top:' + (imgRect.top + imgRect.height / 2 - Math.min(imgRect.height, 120) / 2) + 'px;' +
      'border-radius:12px;overflow:hidden;' +
      'box-shadow:0 8px 30px rgba(44,24,16,0.3);' +
      'transition:all ' + CONFIG.flyDuration + 'ms cubic-bezier(0.2, 0.8, 0.2, 1);';

    var img = document.createElement('img');
    img.src = productImg.src;
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    flyer.appendChild(img);
    document.body.appendChild(flyer);

    // Zielposition berechnen (Mitte des Cart-Icons)
    var targetX = cartRect.left + cartRect.width / 2 - 15;
    var targetY = cartRect.top + cartRect.height / 2 - 15;

    // Animation starten (naechster Frame fuer Transition-Trigger)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        flyer.style.left = targetX + 'px';
        flyer.style.top = targetY + 'px';
        flyer.style.width = '30px';
        flyer.style.height = '30px';
        flyer.style.opacity = '0.6';
        flyer.style.borderRadius = '50%';
        flyer.style.boxShadow = '0 2px 8px rgba(44,24,16,0.2)';
      });
    });

    // Nach Ankunft: Cart-Icon bouncen lassen und Flyer entfernen
    setTimeout(function () {
      flyer.style.opacity = '0';
      flyer.style.transform = 'scale(0)';
      bounceCartIcon();
      setTimeout(function () { flyer.remove(); }, 200);
    }, CONFIG.flyDuration);
  }

  // ============================================================
  // CART-ICON BOUNCE (das ganze Icon, nicht nur die Zahl)
  // ============================================================
  function bounceCartIcon() {
    // Kaffeesack: a.cartToggle ist das Warenkorb-Icon im Header
    var cartEl =
      document.querySelector('a.cartToggle') ||
      document.querySelector('.header__cart') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[data-cart-count]');

    if (cartEl) {
      cartEl.classList.remove('ks-cart-bounce');
      void cartEl.offsetWidth;
      cartEl.classList.add('ks-cart-bounce');
    }

    // Auch den Counter bouncen
    var badge = document.querySelector('.cart-count');
    if (badge) {
      badge.classList.remove('ks-count-bump');
      void badge.offsetWidth;
      badge.classList.add('ks-count-bump');
    }
  }

  // ============================================================
  // BUTTON ANIMATION (Pulse + Farbwechsel + Haekchen)
  // ============================================================
  function animateButton(btn) {
    if (!btn || btn.classList.contains('ks-atc--animating')) return;

    var originalHTML = btn.innerHTML;
    var originalWidth = btn.offsetWidth;

    // 1. Kurzer Scale-Pulse
    btn.classList.add('ks-atc--pulse');

    // 2. Nach Pulse: Erfolgs-State
    setTimeout(function () {
      btn.classList.remove('ks-atc--pulse');
      btn.style.minWidth = originalWidth + 'px';
      btn.classList.add('ks-atc--animating', 'ks-atc--success');
      btn.innerHTML = CHECKMARK_SVG + ' <span>Hinzugef&uuml;gt!</span>';
    }, 200);

    // 3. Sound + Haptic beim Erfolg
    setTimeout(function () {
      playSuccessSound();
      hapticFeedback();
    }, 250);

    // 4. Zurueck zum Original
    setTimeout(function () {
      btn.classList.add('ks-atc--reverting');
      setTimeout(function () {
        btn.classList.remove('ks-atc--animating', 'ks-atc--success', 'ks-atc--reverting');
        btn.innerHTML = originalHTML;
        btn.style.minWidth = '';
      }, 300);
    }, CONFIG.buttonSuccessDuration);
  }

  // ============================================================
  // MOBILE CONFIRM BAR (eleganter als ein Toast)
  // Zeigt Produktbild + Titel + "Warenkorb ansehen" Button
  // ============================================================
  function showMobileConfirmBar(productTitle) {
    if (window.innerWidth >= 768) return;

    var existing = document.querySelector('.ks-confirm-bar');
    if (existing) existing.remove();

    // Produktbild-URL holen
    var productImg =
      document.querySelector('.product-gallery img') ||
      document.querySelector('.product-single__media img') ||
      document.querySelector('.product__media img');
    var imgSrc = productImg ? productImg.src.replace(/(\?.*)?$/, '?width=80') : '';

    var bar = document.createElement('div');
    bar.className = 'ks-confirm-bar';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<div class="ks-confirm-bar__inner">' +
      (imgSrc ? '<img class="ks-confirm-bar__img" src="' + imgSrc + '" alt="">' : '') +
      '<div class="ks-confirm-bar__text">' +
      '<span class="ks-confirm-bar__check">' + CHECKMARK_SVG + '</span>' +
      '<span class="ks-confirm-bar__title">' + productTitle + '</span>' +
      '</div>' +
      '<button class="ks-confirm-bar__btn">Warenkorb ansehen</button>' +
      '</div>';

    // Click-Handler: Theme's eigenen Cart-Toggle klicken
    // Das Theme handled dann alles selbst (Content laden, Banner, Drawer oeffnen)
    bar.querySelector('.ks-confirm-bar__btn').addEventListener('click', function () {
      bar.classList.remove('ks-confirm-bar--visible');
      setTimeout(function () { bar.remove(); }, 400);

      var cartToggle =
        document.querySelector('a.cartToggle') ||
        document.querySelector('.header__cart') ||
        document.querySelector('a[href="/cart"]');

      if (cartToggle) {
        cartToggle.click();
      } else {
        // Fallback: Drawer manuell oeffnen
        document.body.classList.add(CONFIG.cartDrawerOpenClass);
      }
    });

    document.body.appendChild(bar);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.classList.add('ks-confirm-bar--visible');
      });
    });

    // Auto-hide
    setTimeout(function () {
      bar.classList.remove('ks-confirm-bar--visible');
      setTimeout(function () { bar.remove(); }, 400);
    }, CONFIG.confirmBarDuration);
  }

  // ============================================================
  // PRODUKT-TITEL
  // ============================================================
  function getProductTitle() {
    var el =
      document.querySelector('.product__title h1') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1');
    return el ? el.textContent.trim() : 'Dein Produkt';
  }

  // ============================================================
  // GESAMTE SUCCESS-SEQUENZ
  // Orchestriert alle Effekte in der richtigen Reihenfolge
  // ============================================================
  function onAddToCartSuccess() {
    var btn = document.querySelector('button[name="add"], button[data-add-to-cart]');
    var title = getProductTitle();

    // 1. Sofort: Button-Animation starten
    animateButton(btn);

    // 2. Nach 150ms: Fly-to-Cart starten
    setTimeout(function () {
      flyToCart();
    }, 150);

    // 3. Nach Fly-Ankunft: Mobile Confirm Bar
    // Desktop: Das Theme oeffnet den Cart-Drawer selbst — wir greifen nicht ein.
    // Mobile: Wir zeigen eine elegante Bestaetigungs-Bar am unteren Rand.
    setTimeout(function () {
      if (window.innerWidth < 768) {
        showMobileConfirmBar(title);
      }
      // Desktop: Theme handled den Drawer/Popover eigenstaendig
    }, CONFIG.drawerOpenDelay);
  }

  // ============================================================
  // PRIMAERER TRIGGER: MutationObserver auf den Button
  // Das Theme setzt 'product__form-submit--success' auf den Button
  // nach erfolgreichem ATC. Das ist zuverlaessiger als der
  // Fetch-Interceptor, weil Shopify-Apps (z.B. Assortion) den
  // fetch-Chain stoeren koennen.
  // ============================================================
  function watchButtons() {
    var buttons = document.querySelectorAll('button[name="add"], button[data-add-to-cart]');
    buttons.forEach(function (btn) {
      if (btn.getAttribute('data-ks-watched')) return;
      btn.setAttribute('data-ks-watched', '1');

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class') {
            var hasSuccess = btn.className.includes('success');
            var wasAnimated = btn.getAttribute('data-ks-last-success');

            if (hasSuccess && !wasAnimated) {
              btn.setAttribute('data-ks-last-success', '1');
              onAddToCartSuccess();
            }
            if (!hasSuccess) {
              btn.removeAttribute('data-ks-last-success');
            }
          }
        });
      });

      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchButtons);
  } else {
    watchButtons();
  }

  new MutationObserver(function () {
    watchButtons();
  }).observe(document.body, { childList: true, subtree: true });

})();
